@if (isMobile()) {
  <mat-tab-group animationDuration="0ms">
    <mat-tab label="Edit">
      <ng-template matTabContent>
        <email-builder-editor
          [initialContentData]="initialContentData()"
          (contentDataChange)="onContentDataChange($event)"
          (isValidChange)="onValidChange($event)"
        />
      </ng-template>
    </mat-tab>
    <mat-tab label="Preview">
      <ng-template matTabContent>
        <email-builder-preview
          [renderedHtml]="previewHtml()"
          [subject]="previewSubject()"
          [previewText]="previewPreviewText()"
          [contactProvider]="contactProvider"
          [saveDisabled]="!isValid()"
          (saveClicked)="onSaveClicked()"
          (sendPreviewClicked)="onSendPreviewClicked()"
          (contactSelected)="selectedContact.set($event)"
        />
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <div class="desktop-layout">
    <glxy-resize width="400px" minWidth="300px" maxWidth="70%" appearance="standard">
      <email-builder-editor
        [initialContentData]="initialContentData()"
        (contentDataChange)="onContentDataChange($event)"
        (isValidChange)="onValidChange($event)"
      />
    </glxy-resize>
    <div class="preview-panel">
      @if (preview.isLoading()) {
        <mat-progress-bar mode="indeterminate" />
      }
      <email-builder-preview
        [renderedHtml]="previewHtml()"
        [subject]="previewSubject()"
        [previewText]="previewPreviewText()"
        [contactProvider]="contactProvider"
        [saveDisabled]="!isValid()"
        (saveClicked)="onSaveClicked()"
        (sendPreviewClicked)="onSendPreviewClicked()"
        (contactSelected)="selectedContact.set($event)"
      />
    </div>
  </div>
}
